import React, { Component } from 'react'
import ReactDOM from 'react-dom'
import '../styles/MainView.css'
import logoutIcon from '../images/logout.png'
import key from '../images/key.png'
import Login from './Login'
import Sidebar from './Sidebar'
import ContainerWidget from '../widgets/ContainerWidget'
import RegisteredOrganizations from '../organizations/RegisteredOrganizations'
import RegisteredFarmers from '../farmers/RegisteredFarmers'
import FarmerDataForms from '../farmers/FarmerDataForms'
import OrgRegistration from '../organizations/OrgRegistration'
import CreatedClusters from '../clusters/CreatedClusters'
import ClusterCreation from '../clusters/ClusterCreation'
import SiteDetails from '../sites/SiteDetails'
import SitesListView from '../sites/SitesListView'
import SupplyPlanListView from '../supply_plan/SupplyPlanListView'
import SupplyPlan from '../supply_plan/SupplyPlan'
import ClusterCommitments from '../supply_plan/ClusterCommitments'
import CollectiveMarketing from '../supply_plan/CollectiveMarketing'
import ReportDetails from '../reports/ReportDetails'
import OtherProjectListME from '../other_projects/OtherProjectListME'
import OtherProjectDetails from '../other_projects/OtherProjectDetails'
import DropdownWidget from '../widgets/DropdownWidget'
import APISiteRequest from '../api/APISiteRequest'
import AlertMessage from '../widgets/AlertMessage'
import CalendarView from '../calendar/CalendarView'
import ActivityDetailsView from '../calendar/ActivityDetailsView'
import CalendarActivity from '../calendar/CalendarActivity'
import APIFarmerRequest from '../api/APIFarmerRequest'
import APIClusterRequest from '../api/APIClusterRequest'

class MNEAndAEView extends Component
{
	constructor(props) {
		super(props)
		this.state = {
			accessToken: JSON.parse(sessionStorage.getItem("token")),
			user: JSON.parse(sessionStorage.getItem("user")),
			site: null,
			showConfirmMessage: false
		}
		sessionStorage.setItem("sidebar-item", "calendar")
		this.onContentHeaderClick = this.onContentHeaderClick.bind(this)
		this.handleSidebarEvent = this.handleSidebarEvent.bind(this)
		this.handleContentEvent = this.handleContentEvent.bind(this)
		this.onFarmerSignal = this.onFarmerSignal.bind(this)
		this.setCalendarView = this.setCalendarView.bind(this)
		this.setSiteView = this.setSiteView.bind(this)
		this.setOrganizationView = this.setOrganizationView.bind(this)
		this.setFarmerView = this.setFarmerView.bind(this)
		this.setClusterView = this.setClusterView.bind(this)
		this.setSite = this.setSite.bind(this)
		this.deleteSite = this.deleteSite.bind(this)
		this.archiveCluster = this.archiveCluster.bind(this)
		this.getAllSitesByProvinceId = this.getAllSitesByProvinceId.bind(this)
		this.setOtherProjectView = this.setOtherProjectView.bind(this)
		this.setSupplyPlanView = this.setSupplyPlanView.bind(this)
	}

	onContentHeaderClick(signal, value) {
		const sidebarItem = (Array.isArray(signal))? signal[0]: signal
		switch(sidebarItem) {
			case "calendar":
				this.setCalendarView(value)
				break
			case "sites":
				if(value === "close" || value === "cancel") {
					sessionStorage.setItem("sites-tabId", null)
				}
				let sv
				if(value === "update") {
					sv = value
				}
				else if(value === "delete") {
					this.setState({
						showConfirmMessage: true,
						aMessage: "Are you sure you want to delete this site?",
						siteSignal: signal
					})
					break
				}
				this.setSiteView(sv, signal[1])
				break
			case "organizations":
				if(value === "close" || value === "cancel") {
					sessionStorage.setItem("org-tabId", null)
				}
				let ov
				if(value === "update") {
					ov = value
				}
				this.setOrganizationView(ov, signal[1])
				break
			case "farmers":
				let fv
				if(value === "update") {
					fv = value
				}
				this.setFarmerView(fv, signal[1])
				break
			case "clusters":
				if(value === "close" || value === "cancel") {
					sessionStorage.setItem("cluster-tabId", null)
				}
				let cv
				if(value === "update") {
					cv = value
				}
				else if(value === "dissolve") {
					this.setState({
						showConfirmMessage: true,
						aMessage: "Are you sure you want to archive this cluster?",
						clusterSignal: signal
					})
					break
				}
				this.setClusterView(cv, signal[1])
				break
			case "supply-plan":
				this.setSupplyPlanView()
				break
			case "reports":
				this.setReportView()
				break
			case "other-projects":
				if(value === "close" || value === "cancel") {
					sessionStorage.setItem("projects-tabId", null)
				}
				let opv
				if(value === "update") {
					opv = value
				}
				this.setOtherProjectView(opv, signal[1], signal[2])
				break
			default:
		}
	}

	handleSidebarEvent(value) {
		console.log('handleSidebarEvent MNEAndAEView')
		sessionStorage.setItem("sidebar-item", value)
		switch(value) {
			case "calendar":
				this.setState({content: <ContainerWidget title="CALENDAR"
					onClick={this.onContentHeaderClick}
					content={<CalendarView onSignal={this.setCalendarView} />}
					showAddActivity={true}
					signal={"calendar"} key="calendar" />})
				break
			case "sites":
				sessionStorage.setItem("sites-tabId", null)
				this.setSiteView()
				break
			case "organizations":
				this.setOrganizationView()
				break
			case "farmers":
				this.setFarmerView()
				break
			case "clusters":
				this.setClusterView()
				break
			case "supply-plan":
				this.setSupplyPlanView()
				break
			case "reports":
				this.setReportView()
				break
			case "other-projects":
				this.setOtherProjectView()
				break
			default:
		}
	}

	onFarmerSignal(frm, msg) {
		this.setFarmerView(frm)
		if(msg == null) {
			return
		}
		this.setState({
			showInfoMessage: true,
			aMessage: msg.status + "! " + msg.description
		})
	}

	setSite(id) {
		this.setState({siteId: id})
		const si = sessionStorage.getItem("sidebar-item")
		switch(si) {
			case "calendar":
				this.setCalendarView()
				break
			case "organizations":
				this.setOrganizationView()
				break
			case "farmers":
				this.setFarmerView()
				break
			case "clusters":
				this.setClusterView()
				break
			case "reports":
				this.setReportView()
		}
	}

	setSiteView(view, siteId, siteName) {
		console.log('setSiteView', view, siteId, siteName)
		sessionStorage.setItem("sites-curr-view", view)
		switch(view) {
			case "view-details":
				const isUpdate = (siteName != "sdh-swg" && siteName != "sdh-lst")? false: true
				var content = <ContainerWidget title="SITE DETAILS"
					content={<SiteDetails siteId={siteId} view={"view-details"}
						onSignal={this.onContentHeaderClick}
						selectView={this.setSiteView} />}
					onClick={this.onContentHeaderClick}
					showUpdate={(this.state.user.role_id == 3)? isUpdate: false}
					showBack={true}
					signal={["sites", siteId, siteName]} key={siteName + Math.random()} />
				break
			case "update":
				content = <ContainerWidget title="UPDATE SITE DETAILS"
					content={<SiteDetails siteId={siteId} view={"update"}
						onSignal={this.onContentHeaderClick}
						selectView={this.setSiteView} />}
					onClick={this.onContentHeaderClick}
					showBack={true}
					signal={["sites", siteId, this.state.siteName]} key={siteName + Math.random()} />
				break
			default:
				this.getAllSitesByProvinceId()
				content = <ContainerWidget title="SITES"
					content={<SitesListView createSite={this.setSiteView}
					viewDetails={this.setSiteView} />}
					onClick={this.onContentHeaderClick}
					signal={"sites"} key="sc" />
		}
		this.setState({content: content, siteName: siteName})
	}

	deleteSite() {
		const sites = APISiteRequest.deleteSite(this.state.accessToken, this.state.siteSignal[1])
		sites.then((response) => {
			if(response.status === "FAILED") {
				return
			}
			this.setSiteView()
			this.setState({
				showConfirmMessage: false,
				showInfoMessage: true,
				aMessage: "Site " + this.state.siteSignal[2] + " deleted."
			})
		})
	}

	archiveCluster() {
		const sites = APIClusterRequest.deleteClusterById(this.state.accessToken, this.state.clusterSignal[1])
		sites.then((response) => {
			if(response.status === "FAILED") {
				return
			}
			this.setClusterView()
			this.setState({
				showConfirmMessage: false,
				showInfoMessage: true,
				aMessage: "Cluster " + this.state.clusterSignal[0] + " has been archived."
			})
		})
	}

	setCalendarView(view, activityId, status) {
		console.log('user', this.state.user.role_id)
		switch(view) {
			case "add-activity":
				sessionStorage.setItem("activity-tabId", null)
				var content = <ContainerWidget title="ADD ACTIVITY FORM"
					onClick={this.onContentHeaderClick}
					content={<ActivityDetailsView onSignal={this.setCalendarView} />}
					showClose={true}
					signal={"calendar"} key={view} />
				break
			case "update-activity":
				sessionStorage.setItem("activity-tabId", null)
				content = <ContainerWidget title="UPDATE ACTIVITY"
					onClick={this.onContentHeaderClick}
					content={<ActivityDetailsView onSignal={this.setCalendarView}
						activityId={activityId} status={status} view="ad" />}
					showClose={true}
					signal={"calendar"} key={view} />
				break
			case "encode-attendance":
				sessionStorage.setItem("activity-tabId", "adh-attendance")
				content = <ContainerWidget title="UPDATE ACTIVITY"
					onClick={this.onContentHeaderClick}
					content={<ActivityDetailsView onSignal={this.setCalendarView}
						activityId={activityId} status={status} view="ea" />}
					showClose={true}
					signal={"calendar"} key={view} />
				break
			default:
				content = <ContainerWidget title="CALENDAR"
					onClick={this.onContentHeaderClick}
					content={<CalendarView onSignal={this.setCalendarView} />}
					showAddActivity={(this.state.user.role_id == 3)? true: false}
					signal={"calendar"} key={"cldr-" + Math.random()} />
		}
		this.setState({content: content})
	}

	setOrganizationView(view, arboId) {
		let siteId = localStorage.getItem("siteId")
		sessionStorage.setItem("arbo-id", arboId)
		switch(view) {
			case "registration":
				sessionStorage.setItem("org-tabId", null)
				var content = <ContainerWidget title="ORGANIZATION REGISTRATION FORM"
					content={<OrgRegistration />}
					onClick={this.onContentHeaderClick}
					showBack={true}
					signal={"organizations"} key={"orf" + siteId++} />
				break
			case "view-details":
				sessionStorage.setItem("org-tabId", null)
				content = <ContainerWidget title="ORGANIZATION DETAILS"
					content={<OrgRegistration id={arboId} isViewDetails={true} />}
					onClick={this.onContentHeaderClick}
					showUpdate={(this.state.user.role_id == 3)? true: false}
					showBack={true}
					signal={["organizations", arboId]} key={"od" + siteId++} />
				break
			case "update":
				content = <ContainerWidget title="UPDATE ORGANIZATION DETAILS"
					content={<OrgRegistration id={arboId} />}
					onClick={this.onContentHeaderClick}
					showBack={true}
					showCancel={true}
					signal={"organizations"} key={"uod" + siteId++} />
				break
			default:
				content = <ContainerWidget title="ORGANIZATIONS"
					content={<RegisteredOrganizations onRegisterClick={this.setOrganizationView}
						viewDetails={this.setOrganizationView} />}
					onClick={this.onContentHeaderClick}
					signal={"organizations"} key={"ro" + siteId++} />
		}
		this.setState({content: content})
	}

	setFarmerView(view, farmerId) {
		let siteId = localStorage.getItem("siteId")
		switch(view) {
			case "registration":
				sessionStorage.setItem("farmer-tabId", null)
				var content = <ContainerWidget title="FARMER REGISTRATION"
					content={<FarmerDataForms onSignal={this.onFarmerSignal} siteId={siteId} />}
					onClick={this.onContentHeaderClick}
					showCancel={true}
					signal={"farmers"} key="frf" />
				break
			case "view-details":
				sessionStorage.setItem("farmer-tabId", null)
				const farmer = APIFarmerRequest.getFarmerDetailsById(this.state.accessToken, parseInt(farmerId))
				farmer.then((response) => {
					if(response.status === "FAILED") {
						return
					}
					let updateBtn = true
					if(response.results.farmerRegistration.participation_status_id == 2) {
						updateBtn = false
					}
					content = <ContainerWidget title="FARMER DETAILS VIEW"
					content={<FarmerDataForms onSignal={this.onFarmerSignal}
						farmerId={farmerId} view={"view-details"}
						viewClusterDetails={this.setClusterView}
						regStatus={response.results.farmerRegistration.participation_status_id} />}
					onClick={this.onContentHeaderClick}
					showUpdate={(this.state.user.role_id == 3)? updateBtn: false}
					showBack={true}
					signal={["farmers", farmerId]} key="fdv" />
					this.setState({content: content})
					return
				})
				break
			case "update":
				content = <ContainerWidget title="UPDATE FARMER DETAILS"
					content={<FarmerDataForms farmerId={farmerId} view={"update"}
						onSignal={this.onFarmerSignal}
						viewClusterDetails={this.setClusterView}
						siteId={siteId} />}
					onClick={this.onContentHeaderClick}
					showBack={true}
					showCancel={true}
					signal={"farmers"} key="ufd" />
				break
			default:
				content = <ContainerWidget title="REGISTERED FARMERS"
					content={<RegisteredFarmers accesToken={this.state.accessToken}
						onRegisterClick={this.setFarmerView} viewDetails={this.setFarmerView}
						site={siteId} />}
					onClick={this.onContentHeaderClick}
					signal={"farmers"} key={"rf" + siteId++} />
		}
		this.setState({content: content})
	}

	setClusterView(view, clusterId, name, tabId) {
		sessionStorage.setItem("cluster-id", clusterId)
		sessionStorage.setItem("cluster-curr-view", view)
		const isUpdate = (tabId == "cch-target")? false: true
		switch(view) {
			case "create":
				sessionStorage.setItem("cluster-tabId", null)
				var content = <ContainerWidget title="CLUSTER CREATION FORM"
					content={<ClusterCreation selectView={this.setClusterView} />}
					onClick={this.onContentHeaderClick}
					showCancel={true}
					signal={"clusters"} key={tabId + Math.random()} />
				break
			case "view-details":
				sessionStorage.setItem("cluster-name", name)
				content = <ContainerWidget title={"CLUSTER " + name.toUpperCase() + " DETAILS"}
					content={<ClusterCreation id={clusterId} isViewDetails={true}
						selectView={this.setClusterView} name={name} />}
					onClick={this.onContentHeaderClick}
					showUpdate={(this.state.user.role_id == 3)? isUpdate: false}
					showBack={true}
					signal={["clusters", clusterId]} key={'view-details' + Math.random()} />
				break
			case "update":
				const n = sessionStorage.getItem("cluster-name")
				content = <ContainerWidget title={"CLUSTER " + n.toUpperCase() + " DETAILS"}
					content={<ClusterCreation id={clusterId} isViewDetails={false}
						selectView={this.setClusterView} name={n} />}
					onClick={this.onContentHeaderClick}
					showCancel={true}
					showBack={true}
					signal={["clusters", clusterId]} key={'update' + Math.random()} />
				break
			default:
				sessionStorage.setItem("cluster-tabId", null)
				content = <ContainerWidget title="CLUSTERS"
					content={<CreatedClusters onRegisterClick={this.setClusterView} viewDetails={this.setClusterView} />}
					onClick={this.onContentHeaderClick}
					signal={"clusters"} key={"cc" + this.state.siteId++} />
		}
		this.setState({content: content})
	}

	setSupplyPlanView(view, clusterId, name, planId, targetCropId, data, ciid) {
		console.log('setSupplyPlanView',view, clusterId, name, planId, targetCropId, data, ciid)
		sessionStorage.setItem("cluster-id", clusterId)
		switch(view) {
			case "add-supply-plan":
				sessionStorage.setItem("cluster-tabId", null)
				var content = <ContainerWidget title="ADD CLUSTER/S' COMMITMENT TO BUYER"
					content={<SupplyPlan setView={this.setSupplyPlanView} />}
					onClick={this.onContentHeaderClick}
					showCancel={true}
					signal={"supply-plan"} key="ccf" />
				break
			case "view-details":
				var content = <ContainerWidget title="CLUSTER/S' COMMITMENT TO BUYER"
					content={<SupplyPlan setView={this.setSupplyPlanView} spid={planId} />}
					onClick={this.onContentHeaderClick}
					showBack={true}
					signal={"supply-plan"} key="vdsp" />
				break
			case "update":
				var content = <ContainerWidget title="UPDATE CLUSTER/S' COMMITMENT TO BUYER"
					content={<SupplyPlan setView={this.setSupplyPlanView} spid={planId} />}
					onClick={this.onContentHeaderClick}
					showBack={true}
					signal={"supply-plan"} key="usp" />
				break
			case "encode-commitments":
				var content = <ContainerWidget title={`ENCODING (${name}) CLUSTER COMMITMENTS`}
				content={<ClusterCommitments targetCropId={targetCropId} spid={planId} data={data}
					clusterId={clusterId} ciid={ciid} setView={this.setSupplyPlanView} />}
				onClick={this.onContentHeaderClick}
				signal={"encode-commitments"} key="ecc" />
				break
			case "collective-marketing":
				var content = <ContainerWidget title={`COLLECTIVE (${name}) MARKETING`}
					content={<CollectiveMarketing targetCropId={targetCropId} spid={planId}
					deliveryData={data} ciid={ciid} setView={this.setSupplyPlanView} />}
				onClick={this.onContentHeaderClick}
				signal={"collective-marketing"} key="CM" />
				break
			default:
				content = <ContainerWidget title="SUPPLY COMMITMENT AND COLLECTIVE MARKETING"
					content={<SupplyPlanListView addSupplyPlan={this.setSupplyPlanView}
					viewDetails={this.setSupplyPlanView} />}
					onClick={this.onContentHeaderClick}
					signal={"supply-plan"} key="splv" />
		}
		this.setState({content: content})
	}

	setReportView() {
		let siteId = localStorage.getItem("siteId")
		console.log('setReportView()', siteId)
		this.setState({content: <ContainerWidget title="REPORTS"
			content={<ReportDetails/>} key="reports" siteId={siteId} />})
	}

	setOtherProjectView(view, projectId, name) {
		sessionStorage.setItem("project-id", projectId)
		switch(view) {
			case "view-details":
				sessionStorage.setItem("projects-tabId", null)
				var content = <ContainerWidget title="PROJECT DETAILS"
					content={<OtherProjectDetails pid={projectId} projectName={name} isViewDetails={true} />}
					onClick={this.onContentHeaderClick}
					showUpdate={true}
					showClose={true}
					signal={["other-projects", projectId, name]} key="pdvd" />
				break
			case "update":
				content = <ContainerWidget title="PROJECT DETAILS"
					content={<OtherProjectDetails pid={projectId} projectName={name} isViewDetails={false} />}
					onClick={this.onContentHeaderClick}
					showClose={true}
					signal={["other-projects", projectId, name]} key="pdud" />
				break
			default:
				content = <ContainerWidget title="OTHER PROJECTS"
					content={<OtherProjectListME viewDetails={this.setOtherProjectView} />}
					onClick={this.onContentHeaderClick}
					signal={"other-projects"} key={"op" + this.state.siteId++} />
		}
		this.setState({content: content})
	}

	handleContentEvent(e) {
	}

	getAllSitesByProvinceId() {
		const sites = APISiteRequest.getAllSitesByProvinceId(this.state.accessToken, this.state.user.province_id)
		sites.then((response) => {
			console.log('getAllSitesByProvinceId', response, this.state.user.province_id)
			if(response.status === "FAILED") {
				return
			}
			const c = []
			for(const v of response.results.rows) {
				c.push({id: v.site_id, name: v.name.toUpperCase()})
			}
			this.setState({siteData: c})
		})
	}

	componentWillMount() {
		this.getAllSitesByProvinceId()
	}

	componentDidMount() {
		const siteId = JSON.parse(localStorage.getItem("siteId"))
		if(siteId != null) {
			this.setCalendarView("calendar")
		}
		else {
			this.setSiteView()
			const elem = document.getElementById('site-btn')
			elem.checked = true
		}
	}

	render() {
		return(<div id="main-view">
			<Header user={this.state.user} setSite={this.setSite} siteData={this.state.siteData} />
			<Sidebar type={"account-type"} onMenuItemClick={this.handleSidebarEvent} />
			<ContentPane content={this.state.content} onChangeBody={this.handleContentEvent} />
			{this.state.showInfoMessage == true && <AlertMessage type="information" text={this.state.aMessage}
				onClick={() => {
					this.setState({showInfoMessage: false})
				}} />}
			{this.state.showConfirmMessage == true && <AlertMessage type="confirmation" text={this.state.aMessage}
				onClick={(e) => {
					if(e.target.innerHTML === "NO") {
						this.setState({showConfirmMessage: false})
					}
					else {
						if(this.state.clusterSignal != null) {
							this.archiveCluster()
						}
						else if(this.state.siteSignal != null) {
							this.deleteSite()
						}
					}
				}} />}
		</div>)
	}
}

class Header extends Component
{
	constructor(props) {
		super(props)
		this.state = {
			accessToken: JSON.parse(sessionStorage.getItem("token")),
			user:  JSON.parse(sessionStorage.getItem("user"))
		}
		this.onSiteSelected = this.onSiteSelected.bind(this)
	}

	componentWillMount() {
		const sites = APISiteRequest.getAllSitesByProvinceId(this.state.accessToken, this.state.user.province_id)
		sites.then((response) => {
			if(response.status === "FAILED") {
				return
			}
			const c = []
			for(const v of response.results.rows) {
				c.push({id: v.site_id, name: v.name.toUpperCase()})
			}
			this.onSiteSelected(c[0].id, c[0].name)
			this.setState({siteData: c})
		})
	}

	componentDidUpdate(prevProps) {
		if(prevProps.siteData != this.props.siteData) {
			this.setState({siteData: this.props.siteData})
		}
	}

	onSiteSelected(id, name) {
		localStorage.setItem("siteId", id)
		localStorage.setItem("siteName", name)
		this.props.setSite(id)
	}

	render() {
		const extName = (this.props.user.extension_name == null)? "": this.props.user.extension_name
		const mi = (this.props.user.middle_name == null)? "": this.props.user.middle_name
		const name = this.props.user.first_name + " " + mi + " " + this.props.user.last_name + " " + extName
		const view = <div id="header">
			<div id="header-site">
				<div id="title">LINKSFARMM MELA</div>
				{this.state.siteData != null && <Site data={this.state.siteData} onSiteSelected={this.onSiteSelected} />}
			</div>
			<div id="account-name">
				<div id="role">{this.props.user.role}</div>
				<ul><li class="drop">
					<button>{name.toUpperCase()}</button>
					<div class="dropdown">
						<div class="dropout">
							<ul>
								<li id="change-pw" onClick={() => {
									console.log("CHANGE PASSWORD")
								}}><span>
									<img src={key} />
									<label>CHANGE PASSWORD</label>
								</span></li>
								<li id="logout" onClick={() => {
									ReactDOM.render(<Login />, document.getElementById("app"))
								}}><span>
									<img src={logoutIcon} />
									<label>LOGOUT</label>
								</span></li>
							</ul>
						</div>
					</div>
				</li></ul>
			</div>
		</div>
		return(view)
	}
}

function Site(props) {
	let v
	if(props.data.length === 1) {
		v = <div id="site">
			<div>SITE</div>
			<input type='text' placeholder={props.data[0].name.toUpperCase()} disabled={true} />
		</div>
	}
	else {
		v = <div id="site">
			<div>SITE</div>
			<DropdownWidget list={props.data} placeholder={props.data[0].name.toUpperCase()} onItemSelected={(id, val) => {
					props.onSiteSelected(id, val)
				}} cStyle={{"width": "calc(100% - 5px)"}} />
		</div>
	}
	return(v)
}

function ContentPane(props) {
	return(<div id="content-pane">
		{props.content}
	</div>)
}

export default MNEAndAEView
